import { BaserowClient } from "./baserow-client";

/**
 * Operations for managing Baserow user sources.
 */
export class UserSourceOperations {
  constructor(private client: BaserowClient) {}
  
  // User source methods will be implemented here
} 